import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi} from '../../utils/functions';
import {UserContext} from '../../utils/usercontext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Modal from 'react-bootstrap/Modal';
import ProgressBar from 'react-bootstrap/ProgressBar';

import './css/chroma.css';

export default class DJAreaChroma extends React.Component {
	static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			show: this.props.show ? true : false,
			chroma: {
				active: 1,
				rgb: '00ff00',
				similarity: 400,
				smoothness: 80,
				keycolor: 100,
				opacity: 1,
				contrast: 0,
				brightness: 0,
				gamma: 0,
			},
		}
		this.close = this.close.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.defaults = this.defaults.bind(this);
		this.submitEvent = this.submitEvent.bind(this);
	};

	async componentDidMount() {

		let params = new URLSearchParams();
		const x = await postApi('/api/v2/djarea/chroma', params);
		this.setState({chroma: x.data});
		console.log(x.data);
	}

	componentWillUnmount() {
	}

	close() {
		this.setState({ show: false });
		this.props.close();
	}

	handleChange(event) {
		let chroma = {...this.state.chroma};
		let item = event.target.value;
		if( event.target.name === 'active' ) {
			if( event.target.checked ) chroma.active = 1; else chroma.active = 0;
		}
		if( event.target.name === 'rgb' ) {
			chroma.rgb = item;
		}
		if( event.target.name === 'similarity' ) {
			let similarity = parseInt(item);
			if( similarity < 1 ) similarity = 1;
			if( similarity > 1000 ) similarity = 1000;
			chroma.similarity = similarity;
		}
		if( event.target.name === 'smoothness' ) {
			let smoothness = parseInt(item);
			if( smoothness < 1 ) smoothness = 1;
			if( smoothness > 1000 ) smoothness = 1000;
			chroma.smoothness = smoothness;
		}
		if( event.target.name === 'keycolor' ) {
			let keycolor = parseInt(item);
			if( keycolor < 1 ) keycolor = 1;
			if( keycolor > 1000 ) keycolor = 1000;
			chroma.keycolor = keycolor;
		}
		if( event.target.name === 'opacity' ) {
			let opacity = parseFloat(item);
			if( opacity < 0 ) opacity = 0;
			if( opacity > 1 ) opacity = 1;
			chroma.opacity = opacity;
		}
		if( event.target.name === 'contrast' ) {
			let contrast = parseFloat(item);
			if( contrast < -4 ) contrast = 4;
			if( contrast > 4 ) contrast = 4;
			chroma.contrast = contrast;
		}
		if( event.target.name === 'brightness' ) {
			let brightness = parseFloat(item);
			if( brightness < -1 ) brightness = -1;
			if( brightness > 1 ) brightness = 1;
			chroma.brightness = brightness;
		}
		if( event.target.name === 'gamma' ) {
			let gamma = parseFloat(item);
			if( gamma < -1 ) gamma = -1;
			if( gamma > 1 ) gamma = 1;
			chroma.gamma = gamma;
		}

		this.setState({chroma});
	}

	async defaults() {
		if( window.confirm("Are you sure you wish to reset to the default values?") ) {
			this.setState({chroma: {
				active: 1,
				rgb: '00ff00',
				similarity: 400,
				smoothness: 80,
				keycolor: 100,
				opacity: 1,
				contrast: 0,
				brightness: 0,
				gamma: 0,
			}});
		}
	}

	async submitEvent() {
		let params = new URLSearchParams();
		for( let i in this.state.chroma ) {
			params.append(i, this.state.chroma[i]);
		}
		await putApi('/api/v2/djarea/chroma', params);
	}

	render() {
		let user = this.context;
		return (
			<Modal show={this.state.show} onHide={this.close} backdrop="static" keyboard={false} size="xl" centered>
					<Modal.Header closeButton className="bg-dark">
						<Modal.Title>{user.user?.user?.username} Chroma Key Settings</Modal.Title>
					</Modal.Header>
					<Modal.Body className="bg-dark">
						<Form>
						<table width="100%">
							<thead>
								<th width="33%">
									Enabled
								</th>

								<th width="33%">
									<Form.Check // prettier-ignore
										type="switch"
										id="active"
										name="active"
										label={this.state.chroma.active===1?'On':'Off'}
										className="mb-3"
										onChange={this.handleChange}
									/>
								</th>
								<th width="33%">
								</th>
							</thead>
							<tbody>
								<tr>
									<td>
										Key Color (HTML)
									</td>
									<td>
										<div style={{backgroundColor: `#${this.state.chroma.rgb}`, width: '100%', height: '100%'}}>&nbsp;</div>
									</td>
									<td>
										<InputGroup className="mb-3" size="sm">
											<InputGroup.Text id="basic-addon1">#</InputGroup.Text>
											<Form.Control type="text" name="rgb" id="rgb" defaultValue={'00ff00'} value={this.state.chroma.rgb.toUpperCase()} onChange={this.handleChange} disabled={this.state.chroma.active===0} className="form-control-sm" placeholder="00ff00" />
										</InputGroup>
									</td>
									<td>
									</td>
								</tr>
								<tr>
									<td>
										Similarity
									</td>
									<td>
										<ProgressBar now={this.state.chroma.similarity/1000*100} label={this.state.chroma.similarity} />
									</td>
									<td>
										<InputGroup className="mb-3" size="sm">
											<Form.Control type="number" name="similarity" id="similarity" defaultValue={400} value={this.state.chroma.similarity} onChange={this.handleChange} disabled={this.state.chroma.active===0} className="form-control-sm" placeholder="400" />
										</InputGroup>
									</td>
								</tr>
								<tr>
									<td>
										Smoothness
									</td>
									<td>
										<ProgressBar now={this.state.chroma.smoothness/1000*100} label={this.state.chroma.smoothness} />
									</td>
									<td>
										<InputGroup className="mb-3" size="sm">
											<Form.Control type="number" name="smoothness" id="smoothness" defaultValue={400} value={this.state.chroma.smoothness} onChange={this.handleChange} disabled={this.state.chroma.active===0} className="form-control-sm" placeholder="400" />
										</InputGroup>
									</td>
								</tr>
								<tr>
									<td>
										Key Color Spill
									</td>
									<td>
										<ProgressBar now={this.state.chroma.keycolor/1000*100} label={this.state.chroma.keycolor} />
									</td>
									<td>
										<InputGroup className="mb-3" size="sm">
											<Form.Control type="number" name="keycolor" id="keycolor" defaultValue={400} value={this.state.chroma.keycolor} onChange={this.handleChange} disabled={this.state.chroma.active===0} className="form-control-sm" placeholder="400" />
										</InputGroup>
									</td>
								</tr>
								<tr>
									<td>
										Opacity
									</td>
									<td>
										<ProgressBar now={this.state.chroma.opacity/1*100} label={this.state.chroma.opacity} />
									</td>
									<td>
										<InputGroup className="mb-3" size="sm">
											<Form.Control type="number" step="0.0001" name="opacity" id="opacity" defaultValue={400} value={this.state.chroma.opacity} onChange={this.handleChange} disabled={this.state.chroma.active===0} className="form-control-sm" placeholder="400" />
										</InputGroup>
									</td>
								</tr>
								<tr>
									<td>
										Contrast
									</td>
									<td>
										<ProgressBar now={(this.state.chroma.contrast+4)/8*100} label={this.state.chroma.contrast} />
									</td>
									<td>
										<InputGroup className="mb-3" size="sm">
											<Form.Control type="number" step="0.01" name="contrast" id="contrast" defaultValue={400} value={this.state.chroma.contrast} onChange={this.handleChange} disabled={this.state.chroma.active===0} className="form-control-sm" placeholder="400" />
										</InputGroup>
									</td>
								</tr>
								<tr>
									<td>
										Brightness
									</td>
									<td>
										<ProgressBar now={(this.state.chroma.brightness+1)/2*100} label={this.state.chroma.brightness} />
									</td>
									<td>
										<InputGroup className="mb-3" size="sm">
											<Form.Control type="number" step="0.0001" name="brightness" id="brightness" defaultValue={400} value={this.state.chroma.brightness} onChange={this.handleChange} disabled={this.state.chroma.active===0} className="form-control-sm" placeholder="400" />
										</InputGroup>
									</td>
								</tr>
								<tr>
									<td>
										Gamma
									</td>
									<td>
										<ProgressBar now={(this.state.chroma.gamma+1)/2*100} label={this.state.chroma.gamma} />
									</td>
									<td>
										<InputGroup className="mb-3" size="sm">
											<Form.Control type="number" step="0.01" name="gamma" id="gamma" defaultValue={400} value={this.state.chroma.gamma} onChange={this.handleChange} disabled={this.state.chroma.active===0} className="form-control-sm" placeholder="400" />
										</InputGroup>
									</td>
								</tr>
							</tbody>
						</table>
						</Form>

					</Modal.Body>
					<Modal.Footer className="bg-dark">
							<Button size="sm" variant="secondary" onClick={this.defaults}>Defaults</Button>
							<Button size="sm" variant="primary" onClick={this.submitEvent}>Save Changes</Button>
							<Button size="sm" variant="secondary" onClick={this.close}>Close</Button>
						</Modal.Footer>
					</Modal>
		);
	}
}
